<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
</script>

<div class="skeleton-loader"></div>

<style>
  .skeleton-loader {
    height: 1rem;
    width: 500px;
    margin: 12px 0 1.75rem;
    position: relative;
    background-color: #dbd9d7;
    background-image: -webkit-linear-gradient(
      120deg,
      #dbd9d7 0px,
      var(--bg-color) 50px,
      #dbd9d7 100px
    );
    background-image: -o-linear-gradient(
      120deg,
      #dbd9d7 0px,
      var(--bg-color) 50px,
      #dbd9d7 100px
    );
    background-image: linear-gradient(
      120deg,
      #dbd9d7 0px,
      var(--bg-color) 50px,
      #dbd9d7 100px
    );
    background-size: 600px;
    -webkit-animation: shine-loading-image 3s infinite ease-out;
    animation: shine-loading-image 3s infinite ease-out;
    background-repeat: no-repeat;
  }

  .skeleton-loader:after {
    content: "";
    height: 1rem;
    width: 75%;
    display: inline-block;
    position: absolute;
    top: 1.5rem;
    background-color: #dbd9d7;
    background-image: -webkit-linear-gradient(
      120deg,
      #dbd9d7 0px,
      var(--bg-color) 50px,
      #dbd9d7 100px
    );
    background-image: -o-linear-gradient(
      120deg,
      #dbd9d7 0px,
      var(--bg-color) 50px,
      #dbd9d7 100px
    );
    background-image: linear-gradient(
      120deg,
      #dbd9d7 0px,
      var(--bg-color) 50px,
      #dbd9d7 100px
    );
    background-size: 600px;
    -webkit-animation: shine-loading-image 3s infinite ease-out;
    animation: shine-loading-image 3s infinite ease-out;
    background-repeat: no-repeat;
  }

  @-webkit-keyframes shine-loading-image {
    0% {
      background-position: -100px;
    }
    40%,
    100% {
      background-position: 600px;
    }
  }

  @keyframes shine-loading-image {
    0% {
      background-position: -100px;
    }
    40%,
    100% {
      background-position: 600px;
    }
  }
</style>
